import React, { useState, useEffect } from "react";
import AlertBase from "react-bootstrap/Alert";

type AlertBootstrapProps = {
  show?: boolean;
  variant?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  dismissible?: boolean;
  persist?: boolean;
};

const BootstrapAlert = AlertBase as React.ElementType;

const AlertBootstrap = ({
  show = false,
  variant = "success",
  icon = "",
  children,
  className = "",
  dismissible = true,
  persist = true,
}: AlertBootstrapProps) => {
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    if (show) {
      setDisplay(true);
    }
    if (!persist) {
      setTimeout(() => {
        setDisplay(false);
      }, 5000);
    }
  }, [show]);

  return (
    <BootstrapAlert
      show={display}
      variant={variant}
      dismissible={dismissible}
      className={className}
    >
      {icon ? icon : null}
      {children}
    </BootstrapAlert>
  );
};

export default AlertBootstrap;
